
export default function (href: string, id: string) {
  let cssNode = document.getElementById(id) as HTMLLinkElement
  if (!cssNode) {
    const head = document.getElementsByTagName('head')[0]
    cssNode = document.createElement('link')
    cssNode.id = id
    cssNode.type = 'text/css'
    cssNode.rel = 'stylesheet'
    cssNode.href = href
    head.appendChild(cssNode)
  } else {
    cssNode.href = href
  }
}
